"use client";

import React from "react";

type Props = {
  session: string;
  accessToken: string;
};
export const GoogleClassroomAuthSuccessView: React.FC<Props> = ({
  session,
  accessToken,
}) => {
  React.useEffect(() => {
    if (session && accessToken) {
      window?.opener?.postMessage(
        {
          type: "oak-google-classroom-auth-complete",
          success: true,
          session,
          accessToken,
        },
        "*",
      );
      setTimeout(() => {
        window.close();
      }, 3000);
    }
  }, [session, accessToken]);
  return <></>;
};
